import { getElement, toggleSpinnerAndContainer, scrollToElementWithOffset } from "../shared/pageComponents"; 

document.addEventListener('DOMContentLoaded', () => {
    toggleSpinnerAndContainer('embla-spinner', 'embla-container', 1000);
});